import axios from "axios";

let url = process.env.REACT_APP_API;
let token = process.env.REACT_APP_API_KEY;

//working
export const getAllBDM = async () => {

    // ${url}/api/v1/User?maxSize=100&offset=0&order=asc&where[0][type]=in&userType=internal&select=salutationName,firstName,lastName,middleName,name,userName,type,usertype,rolesIds,rolesNames,mobileAppstatus,isActive,teamsIds,teamsNames,teamsColumns,title,emailAddressIsOptedOut,emailAddressIsInvalid,emailAddress,emailAddressData&orderBy=userName&where[0][attribute]=usertype&where[0][value][]=BDM

    try {
        let data = await axios.get(
            `${url}/api/v1/User?maxSize=100&offset=0&order=asc&where[0][type]=in&userType=internal&select=salutationName,firstName,lastName,middleName,name,userName,type,usertype,rolesIds,rolesNames,mobileAppstatus,isActive,teamsIds,teamsNames,teamsColumns,title,emailAddressIsOptedOut,emailAddressIsInvalid,emailAddress,emailAddressData&orderBy=userName&where[0][attribute]=cUserType&where[0][value][]=BDM&where[1][type]=isFalse&where[1][attribute]=cIsTestUser
            `, {
            "headers": {
                "Accept": "application/json, text/javascript, /; q=0.01",
                "Accept-Language": "en-US,en;q=0.5",
                'x-api-key': token,
                // "Sec-Fetch-Mode": "no-cors",
            },
            "method": "GET"
        });
        return data
    } catch (err) {
        return err
    }
};
//api not used
export const TodaysMeeting = async () => {
    try {
        let data = await axios.get(`${url}/api/v1/Meeting?select=contactName,name,accountId,accountName,assignedUserId,assignedUserName,checkintime,checkouttime,createdAt&maxSize=100&offset=0&orderBy=dateStart&order=desc&where[0][type]=today&where[0][attribute]=createdAt&where[0][dateTime]=true&where[0][timeZone]=Asia/Kolkata&where[1][type]=or&where[1][value][0][type]=notIn&where[1][value][0][attribute]=accountId&where[1][value][0][value][]=6488566363832d0d7&where[1][value][1][type]=isNull&where[1][value][1][attribute]=accountId`, {
            "headers": {
                "Accept": "application/json, text/javascript, /; q=0.01",
                "Accept-Language": "en-US,en;q=0.5",
                'x-api-key': token,
                // "Sec-Fetch-Mode": "no-cors",
            },
            "method": "GET"
        });
        //console.log(data)
        return data
    } catch (err) {
        return err
    }
};

//same as totalmeeting held today
export const sevenDaysMeet = async (start, end) => {

    // `${url}/api/v1/Meeting?select=contactName,name,accountId,accountName,assignedUserId,assignedUserName,checkintime,checkouttime,createdAt&maxSize=100&offset=0&orderBy=dateStart&order=desc&where[0][type]=lastXDays&where[0][attribute]=createdAt&where[0][value]=7&where[0][dateTime]=true&where[0][timeZone]=Asia/Kolkata&where[1][type]=or&where[1][value][0][type]=notIn&where[1][value][0][attribute]=accountId&where[1][value][0][value][]=6488566363832d0d7&where[1][value][1][type]=isNull&where[1][value][1][attribute]=accountId`
    try {
        let data = await axios.get(`${url}/api/v1/Meeting?select=contactName,feedbackCaptured,name,accountId,accountName,parentId,parentType,parentName,division,assignedUserId,assignedUserName,checkintime,checkouttime,meetingtype,createdAt,dateStart,dateStartDate&maxSize=100&offset=0&orderBy=dateStart&order=asc&where[0][type]=between&where[0][attribute]=dateStart&where[0][value][]=${end}&where[0][value][]=${start}&where[0][dateTime]=true&where[0][timeZone]=Asia/Kolkata&where[1][type]=in&where[1][attribute]=status&where[1][value][]=Held&where[2][type]=notLinkedWith&where[2][attribute]=contacts&where[2][value][]=66a37f60db8af84ed&where[2][value][]=656456cbbc54d940d`, {
            "headers": {
                "Accept": "application/json, text/javascript, /; q=0.01",
                "Accept-Language": "en-US,en;q=0.5",
                'x-api-key': token,
                // "Sec-Fetch-Mode": "no-cors",
            },
            "method": "GET"
        });
        //console.log(data)
        return data
    }
    catch (err) {
        return err
    }
};

//working
export const TotalOnsites = async (date) => {
    try {
        let data = await axios.get(`${url}/api/v1/Meeting?select=contactName,feedbackCaptured,name,accountId,accountName,parentId,parentType,parentName,division,assignedUserId,assignedUserName,checkintime,checkouttime,meetingtype,createdAt&maxSize=100&offset=0&orderBy=dateStart&order=desc&where[0][type]=on&where[0][attribute]=dateStart&where[0][value]=${date}&where[0][dateTime]=true&where[0][timeZone]=Asia/Kolkata&where[1][type]=notLinkedWith&where[1][attribute]=contacts&where[1][value][]=66a37f60db8af84ed&where[1][value][]=656456cbbc54d940d`, {
            "headers": {
                "Accept": "application/json, text/javascript, /; q=0.01",
                "Accept-Language": "en-US,en;q=0.5",
                'x-api-key':token,
                // "Sec-Fetch-Mode": "no-cors",
            },
            "method": "GET"
        });
        return data
    }
    catch (err) {
        return err
    }
}

///working
export const datewisereport = async (date) => {
    try {
        let data = await axios.get(`${url}/custom_api/hrportal/BDMMeetingReport.php?date=${date}`)
        return data
    } catch (err) {
        return err
    }
};

///working
export const SingleUserReport = async (id, start, end) => {

    // console.log(id, start, end, 67666)

    try {
        // let data = await axios.get(`${url}/report/api/BDMWiseMeetingReportApi.php?start_date=${start}&end_date=${end}&user_id=${id}`)
        let data = await axios.get(`${url}/custom_api/hrportal/BDMWiseMeetingReportApi.php?start_date=${start}&end_date=${end}&user_id=${id}`)
        return data
    } catch (err) {
        return err
    }
};

//working
export const AuthaticateUser = async (email) => {
    try {
        let data = await axios.get(`${url}/api/v1/User?userType=internal&select=%20userName&maxSize=1&offset=0&orderBy=userName&order=asc&where[0][type]=startsWith&where[0][attribute]=emailAddress&where[0][value]=${email}&where[1][type]=linkedWith&where[1][attribute]=teams&where[1][value][]=65855a97c4a8480cf`,
            {
                "headers": {
                    "Accept": "application/json, text/javascript, /; q=0.01",
                    "Accept-Language": "en-US,en;q=0.5",
                    'x-api-key': token,
                    // "Sec-Fetch-Mode": "no-cors",
                }
            }
        )
        return data
    } catch (err) {
        return err
    }
};


// Single User Meeting without Indigi ---
//working
export const MeetingInfo = async (id, date) => {

    // console.log(id,date)

    // `${url}/api/v1/Meeting?select=contactName,name,accountId,accountName,assignedUserId,assignedUserName,checkintime,checkouttime,duration,createdAt&maxSize=100&offset=0&orderBy=dateStart&order=desc&where[0][type]=on&where[0][attribute]=createdAt&where[0][value]=${date}&where[0][dateTime]=true&where[0][timeZone]=Asia/Kolkata&where[1][type]=equals&where[1][attribute]=assignedUserId&where[1][value]=${id}&where[2][type]=isTrue&where[2][attribute]=meetingStaus&where[3][type]=or&where[3][value][0][type]=notEquals&where[3][value][0][attribute]=accountId&where[3][value][0][value]=6488566363832d0d7&where[3][value][1][type]=isNull&where[3][value][1][attribute]=accountId`;


    // let URL = `${url}/api/v1/Meeting?select=contactName,meetingStaus,name,accountId,accountName,duration,division,dateStart,dateStartDate,assignedUserId,assignedUserName,checkintime,checkouttime,feedbackCaptured,meetingtype,createdAt,contactID&maxSize=100&offset=0&orderBy=checkintime&order=asc&where[0][type]=on&where[0][attribute]=checkintime&where[0][value]=${date}&where[0][dateTime]=true&where[0][timeZone]=Asia/Kolkata&where[1][type]=equals&where[1][attribute]=assignedUserId&where[1][value]=${id}&where[2][type]=isTrue&where[2][attribute]=meetingStaus&where[3][type]=in&where[3][attribute]=meetingtype&where[3][value][]=On Site&where[3][value][]=VC&where[4][type]=or&where[4][value][0][type]=notIn&where[4][value][0][attribute]=accountId&where[4][value][0][value][]=6488566363832d0d7&where[4][value][1][type]=isNull&where[4][value][1][attribute]=accountId`
    // let URL = `${url}/api/v1/Meeting?select=contactName,meetingStaus,name,accountId,accountName,duration,division,dateStart,dateStartDate,assignedUserId,assignedUserName,checkintime,checkouttime,feedbackCaptured,meetingtype,createdAt,contactID&maxSize=100&offset=0&orderBy=checkintime&order=asc&where[0][type]=isNotNull&where[0][attribute]=accountId&where[1][type]=on&where[1][attribute]=checkintime&where[1][value]=${date}&where[1][dateTime]=true&where[1][timeZone]=Asia/Kolkata&where[2][type]=equals&where[2][attribute]=assignedUserId&where[2][value]=${id}&where[3][type]=isTrue&where[3][attribute]=meetingStaus&where[4][type]=in&where[4][attribute]=meetingtype&where[4][value][]=VC&where[4][value][]=On Site`
    let URL = `${url}/api/v1/Meeting?maxSize=20&offset=0&orderBy=cCheckIn&order=asc&whereGroup[0][type]=isNotNull&whereGroup[0][attribute]=accountId&whereGroup[0][value]=&whereGroup[1][type]=on&whereGroup[1][attribute]=cCheckIn&whereGroup[1][value]=${date}&whereGroup[1][dateTime]=true&whereGroup[1][timeZone]=Asia/Kolkata&whereGroup[2][type]=in&whereGroup[2][attribute]=status&whereGroup[2][value][]=Held&whereGroup[3][type]=in&whereGroup[3][attribute]=cType&whereGroup[3][value][]=Onsite&whereGroup[3][value][]=Conference&whereGroup[3][value][]=Remote-VC&whereGroup[3][value][]=Office-VC&whereGroup[4][type]=equals&whereGroup[4][attribute]=assignedUserId&whereGroup[4][value]=${id}&attributeSelect=createdAt,description,cOwnerId,cOwnerName,cDivisionId,cDivisionName,assignedUserId,assignedUserName,cCheckOut,cCheckIn,dateStart,dateStartDate,status,cType,parentId,parentType,parentName,accountId,accountName,cCustomerId,cContactName,name`

    try {
        let data = await axios.get(URL, {
            "headers": {
                "Accept": "application/json, text/javascript, /; q=0.01",
                "Accept-Language": "en-US,en;q=0.5",
                'x-api-key': token,
                // "Sec-Fetch-Mode": "no-cors",
            },
            "method": "GET"
        });
        return data
    } catch (err) {
        return err
    }
};

//api not used
export const MeetingInfo_planned = async (id, start, end) => {
    try {
        let data = await axios.get(`${url}/api/v1/Meeting?select=contactName,feedbackCaptured,name,accountId,accountName,parentId,parentType,parentName,division,assignedUserId,assignedUserName,checkintime,checkouttime,meetingtype,createdAt&maxSize=100&offset=0&orderBy=dateStart&order=desc&where[0][type]=in&where[0][attribute]=status&where[0][value][]=Planned&where[1][type]=equals&where[1][attribute]=assignedUserId&where[1][value]=${id}&where[2][type]=between&where[2][attribute]=dateStart&where[2][value][]=${start}&where[2][value][]=${end}&where[2][dateTime]=true&where[2][timeZone]=Asia/Kolkata`, {
            "headers": {
                "Accept": "application/json, text/javascript, /; q=0.01",
                "Accept-Language": "en-US,en;q=0.5",
                'x-api-key': token,
                // "Sec-Fetch-Mode": "no-cors",
            },
            "method": "GET"
        });

        return data
    } catch (err) {
        return err
    }
};

export const GetAllBDM = async () => {
    try {
        let tempdata = [];
        let offset = 0;
        let flag = true;

        const response = await axios.get(`${url}/api/v1/User?userType=internal&maxSize=50&offset=0&orderBy=userName&order=asc&whereGroup[0][type]=in&whereGroup[0][attribute]=cUserType&whereGroup[0][value][]=BDM&whereGroup[1][type]=isTrue&whereGroup[1][attribute]=isActive&whereGroup[1][value]=&attributeSelect=name`, {
            headers: {
                "Accept": "application/json, text/javascript, */*; q=0.01",
                "Accept-Language": "en-US,en;q=0.5",
                'x-api-key': token,
            }
        });

        const list = response.data?.list || [];

        return list;
    } catch (err) {
        return err;
    }
};

///working
export const GetAllmeetings = async (start_date, to_date) => {
    try {
        let tempdata = [];
        let offset = 0;
        let flag = true;

        while (flag) {
            const response = await axios.get(`${url}/api/v1/Meeting?select=name,cType,cContactName,accountName,dateStart,dateEnd&maxSize=200&offset=${offset}&orderBy=dateStart&order=desc&where[0][type]=between&where[0][attribute]=dateStart&where[0][value][]=${start_date}&where[0][value][]=${to_date}&where[0][dateTime]=true&where[0][timeZone]=Asia/Kolkata`, {
                headers: {
                    "Accept": "application/json, text/javascript, */*; q=0.01",
                    "Accept-Language": "en-US,en;q=0.5",
                    'x-api-key': token,
                }
            });

            const list = response.data?.list || [];

            tempdata = [...tempdata, ...list];

            if (list.length < 200) {
                flag = false;
            } else {
                offset += 200;
            }
        }

        return tempdata;
    } catch (err) {
        return err;
    }
};


//working same as seven days meet
export const TotalHeldmeeting_today = async(date) => {
    try {
        let data = await axios.get(`${url}/api/v1/Meeting?select=contactName,feedbackCaptured,name,accountId,accountName,parentId,parentType,parentName,division,assignedUserId,assignedUserName,checkintime,checkouttime,meetingtype,createdAt,dateStart,dateStartDate&maxSize=100&offset=0&orderBy=dateStart&order=asc&where[0][type]=between&where[0][attribute]=dateStart&where[0][value][]=${date}&where[0][value][]=${date}&where[0][dateTime]=true&where[0][timeZone]=Asia/Kolkata&where[1][type]=in&where[1][attribute]=status&where[1][value][]=Held&where[2][type]=notLinkedWith&where[2][attribute]=contacts&where[2][value][]=66a37f60db8af84ed&where[2][value][]=656456cbbc54d940d`, {
            "headers": {
                "Accept": "application/json, text/javascript, /; q=0.01",
                "Accept-Language": "en-US,en;q=0.5",
                'x-api-key': token,
                // "Sec-Fetch-Mode": "no-cors",
            },
            "method": "GET"
        });
        return data
    }
    catch (err) {
        console.log({err})
    }
}